import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { transition, style, animate, trigger } from '@angular/animations';
import { PlaceDetail } from '../../model/places';

const leaveTrans = transition(':leave', [
  style({
    opacity: 1
  }),
  animate('1s ease-out', style({
    opacity: 0
  }))
]);

const fadeOut = trigger('fadeOut', [
  leaveTrans
]);

@Component({
  selector: 'google-search',
  templateUrl: './google-search.component.html',
  styleUrls: ['./google-search.component.scss'],
  animations: [
    fadeOut
  ]
})
export class GoogleSearchComponent implements OnInit, AfterViewInit {

  @Input() order;
  @Input() type;
  @Input() index;
  searchValue: string = '';
  placesList: PlaceDetail[] = [];
  searchBox: google.maps.places.SearchBox;
  districtView: google.maps.Map;

  constructor() { }

  ngOnInit(): void{

  }

  ngAfterViewInit(): void {
    this.districtView = new google.maps.Map(document.getElementById('google_search_view' + this.index), {
      streetViewControl: false,
      zoomControl: false,
      fullscreenControl: false,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    });
    this.initializeSearchBox();
  }

  // initializeSearchBox() - Initialize Searchbox.
  initializeSearchBox(): void {
    this.searchBox = new google.maps.places.SearchBox(document.getElementById('google_search_' + this.index) as HTMLInputElement);

    // Bias the SearchBox results towards current map's viewport.
    this.districtView.addListener('bounds_changed', () => {
      this.searchBox.setBounds(this.districtView.getBounds());
    });

    // more details for that place.
    this.searchBox.addListener('places_changed', () => {
      setTimeout(() => {
        let list = this.searchBox.getPlaces();
        this.placesList = [];
        if (list && list.length > 0) {
          list.map((place) => {
            let placeDetail = new PlaceDetail();
            placeDetail.PLACE = place;
            this.placesList.push(placeDetail);
          });
        }
        //this.redirectToMap();
        this.getPlaceAdditionalInfo();
      }, 500);
    });
  }

  redirectToMap(): void{
    if(this.searchValue)
      window.open('https://www.google.com/maps/search/' + this.searchValue.replace(/' '/g, '+'), '_blank');
  }

  // getPlaceAdditionalInfo() - Get place additional info
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  async getPlaceAdditionalInfo() {
    for (let i = 0; i < this.placesList.length; i++) {
      // If we have already got place detail then don't call API again
      await this.placeInfo(this.placesList[i]);
    }
  }

  // placeInfo() - Get place info of place
  placeInfo(place): any {
    return new Promise((resolve) => {
      let service = new google.maps.places.PlacesService(this.districtView);
      var request = {
        placeId: place.PLACE.place_id,
        fields: ['rating', 'formatted_phone_number', 'website']
      };

      if(service){
        place.SHOW_DETAIL_LOADING = true;
        service.getDetails(request, (details, status) => {
          if (status == google.maps.places.PlacesServiceStatus.OK) {
            place.NUMBER = details.formatted_phone_number;
            place.RATING = details.rating;
            place.WEBSITE = details.website;
            place.SHOW_EXTRA_DETAIL = true;
            place.SHOW_DETAIL_LOADING = false;
            place.IS_EXTRA_DETAILS_GET = true;
          }
          resolve(true);
        });
      }else
        resolve(true);
    });
  }

  /* To copy any Text */
  copyText(place: PlaceDetail, type: number): void {
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';

    switch (type) {
    case 1:
      selBox.value = place.PLACE.name + ' ' + place.RATING;
      break;
    case 2:
      selBox.value = place.PLACE.formatted_address;
      break;
    case 3:
      selBox.value = place.NUMBER;
      break;
    case 4:
      selBox.value = place.WEBSITE;
      break;
    default:
      break;
    }

    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);

    if(!place.COPIED){
      place.COPIED = true;
      setTimeout(() => { place.COPIED = false; }, 2000);
    }
  }
}
